<template>
  <div class="pt-6 flex flex-wrap">
    <div class="flex flex-wrap items-center w-full">
      <div class="relative w-1/6 rounded-lg border-2 p-4 mr-8 items-center justify-center" v-for="(qrCode,key) in qrCodes" :key="key">
        <div class="w-full flex justify-center">
          <img class="w-1/2" :src="'data:image/png;base64,' + qrCode.img" v-if="qrCode.img!==''" >
          <img src="/img/qrcode.svg" width="100" height="100" v-else>
        </div>
        <div class="w-full text-center pt-2 mb-4">
          <div class="w-full text-center pt-4 px-8" v-if="qrCode.title">
            <a :href="qrCode.link | completedUrl" v-if="qrCode.link" target="_blank" :title="qrCode.link | completedUrl">{{qrCode.title}}</a>
            <span v-else>{{qrCode.title}}</span>
          </div>
          <div class="w-full h-24 text-center pt-2 px-2 overflow-auto" v-if="qrCode.description">
            <span v-if="qrCode.title === 'URL'" class="flex justify-center items-center">
              <a :href="qrCode.link | completedUrl" target="_blank" :title="qrCode.link | completedUrl">
                <icon name="link" class="w-3 h-3"></icon>
              </a>
            </span>
            <span v-else>{{qrCode.description}}</span>
          </div>
          <div class="w-full text-center pt-4 px-8">
            {{qrCode.saved_date}}
          </div>
        </div>
        <div class="w-full text-center border-top pt-8 pb-4" v-if="qrCode.description">
          <a :href="'data:image/png;base64,' + qrCode.img" class="bg-primary text-white text-sm p-2 mx-2 no-underline" download>Download QR Code</a>
        </div>

        <div class="w-8 absolute pin-t pin-r m-2" @click="deleteQR(qrCode.id)">
          <icon name="bin" class="cursor-pointer" ></icon>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/http'
import { mapState, mapActions } from 'vuex'

export default {
  data () {
    return {
      qrCodes: []
    }
  },
  components: {
  },
  computed: {
    ...mapState({
      office: state => state.selectedOffice
    })
  },
  watch: {
  },
  methods: {
    ...mapActions(['displayToastNotification']),
    getQrs: function () {
      api.get(`/qr-code/generator/${this.office.id}`).then(response => {
        this.qrCodes = response.data.qr_codes
      }).catch(() => {
        console.log('Unable to get custom QR codes')
      })
    },
    deleteQR: function (id) {
      var result = confirm('Delete this QR?')
      if (result) {
        api.delete(`/qr-code/generator/${id}`).then(response => {
          this.getQrs()
        }).catch(() => {
          console.log('Unable to get custom QR codes')
        })
      }
    }
  },
  mounted () {
    this.getQrs()
  }
}
</script>

<style scoped>
button:focus {
  outline:0;
}

input[type="radio"] {
  display: inline-block;
}

input[type="radio"] + label {
  cursor: pointer;
  white-space: nowrap;
  display: inline-block;
  position: relative;
  line-height: 1rem;
}

input[type="radio"]:checked + label::before {
  content: "";
  border-width: 0px;
}

input[type="radio"]:checked + label::before {
  background: white;
}
input[type="radio"] + label::before {
  content: '';
  display: inline-block;
  width: 0px;
  height: 0px;
  margin-right: 5px;
  border: 0px;
  padding: 0px;
  background: white;
}
</style>
